import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import { Order } from '../../types/repropark-api/order'

export const ordersReproparkApi = createApi({
    reducerPath: 'ordersReproparkApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['ReproparkOrders'],
    endpoints: builder => ({
        // getOrders: builder.query<any, void>({
        //     // query:
        // }),
        getOrderById: builder.query<Order, string>({
            query: id => ({
                url: `/repropark/v1/orders/${id}/`,
            }),
        }),
    }),
})

export const { useLazyGetOrderByIdQuery } = ordersReproparkApi
